module.exports = __webpack_public_path__ + "static/media/banner3.bf396f15.jpg";